/* OPAAL DESSAU — theme "Dessau" */
(() => {
  'use strict';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const T = window.theme || { strings: {}, routes: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents, format = T.moneyFormat || '€{{amount_with_comma_separator}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const n = (c, decimals = 2, th = '.', dec = ',') => {
      const fixed = (c / 100).toFixed(decimals);
      const [i, f] = fixed.split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return n(cents, 2, ',', '.');
        case 'amount_no_decimals': return n(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return n(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return n(cents, 2, "'", '.');
        default: return n(cents, 2, '.', ',');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (el.hidden = true), 2600);
  }

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;

  function open(name) {
    const el = $(`[data-drawer="${name}"]`);
    if (!el) return false;
    if (openDrawer && openDrawer !== el) close();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    openDrawer = el;
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    document.body.classList.add('has-drawer');
    $$(`[data-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => {
      const focusTarget = el.querySelector('input[type="search"]') || el;
      focusTarget.focus({ preventScroll: true });
    }, 60);
    return true;
  }

  function close() {
    if (!openDrawer) return;
    const name = openDrawer.dataset.drawer;
    openDrawer.classList.remove('is-open');
    $$(`[data-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    openDrawer = null;
    if (overlay) { overlay.classList.remove('is-visible'); setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 300); }
    document.body.classList.remove('has-drawer');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.dataset.open;
      if (name === 'cart-drawer' && T.cartType !== 'drawer') return;
      if ($(`[data-drawer="${name}"]`)) { e.preventDefault(); open(name); }
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); closeLightbox(); }
    if (e.key === 'Tab' && openDrawer) {
      const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', openDrawer).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header scroll state ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(bar => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    let i = 0;
    setInterval(() => {
      if (bar.classList.contains('announcement--inline') && window.innerWidth >= 990) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    const watch = (root = document) => $$('.reveal:not(.is-in)', root).forEach(el => io.observe(el));
    watch();
    document.addEventListener('shopify:section:load', (e) => watch(e.target));
    window.__watchReveal = watch;
  } else {
    $$('.reveal').forEach(el => el.classList.add('is-in'));
  }

  /* ---------- Sliders ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-slide]');
    if (!btn) return;
    const section = btn.closest('section');
    const slider = section && $('[data-slider]', section);
    if (!slider) return;
    const step = slider.firstElementChild ? slider.firstElementChild.getBoundingClientRect().width + 22 : 300;
    slider.scrollBy({ left: step * parseInt(btn.dataset.slide, 10) * 2, behavior: 'smooth' });
  });

  /* ---------- Predictive search ---------- */
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    const initial = searchResults.innerHTML;
    let ctrl;
    let timer;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      if (!q) { searchResults.innerHTML = initial; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
          const res = await fetch(url, { signal: ctrl.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sec = doc.querySelector('#shopify-section-predictive-search');
          searchResults.innerHTML = sec ? sec.innerHTML : '';
        } catch (err) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------- Cart ---------- */
  async function refreshCartDrawer() {
    try {
      const res = await fetch(`${T.routes.root}?sections=cart-drawer`);
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer]');
        const current = $('[data-cart-drawer]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
        }
      }
    } catch (e) { /* ignore */ }
    try {
      const cart = await (await fetch(`${T.routes.cart}.js`)).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count > 0 ? cart.item_count : ''; el.dataset.count = cart.item_count; });
      return cart;
    } catch (e) { return null; }
  }

  async function addToCart(form, button) {
    const fd = new FormData(form);
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(`${T.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      await refreshCartDrawer();
      if (T.cartType === 'drawer' && $('[data-cart-drawer]')) open('cart-drawer');
      else if (T.cartType === 'page') window.location.href = T.routes.cart;
      else toast(T.strings.added);
    } catch (err) {
      toast(err.message || T.strings.error);
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    // let the dynamic checkout button behave natively
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    addToCart(form, e.submitter || form.querySelector('[type="submit"]'));
  });

  async function changeLine(line, quantity) {
    const wrap = $(`[data-line="${line}"]`);
    if (wrap) wrap.style.opacity = '.45';
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, quantity) })
      });
      if (!res.ok) { const d = await res.json(); throw new Error(d.description || d.message); }
      if ($('[data-cart-page]')) { window.location.reload(); return; }
      await refreshCartDrawer();
    } catch (err) {
      toast(err.message || T.strings.error);
      if (wrap) wrap.style.opacity = '';
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const line = btn.closest('[data-line]');
    if (line) changeLine(line.dataset.line, parseInt(btn.dataset.qtyChange, 10));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (input) {
      const line = input.closest('[data-line]');
      if (line) changeLine(line.dataset.line, parseInt(input.value, 10) || 0);
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(`${T.routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });

  /* ---------- Quantity steppers on product page ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty] [data-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', section);
    const idInput = form && $('[data-variant-id]', form);
    const addBtn = form && $('[data-add-button]', form);
    const priceEl = $('[data-product-price] [data-price]', section);
    const stickyBar = $('[data-sticky-atc]', section);
    const track = $('[data-gallery-track]', section);
    const dots = $$('[data-gallery-dots] button', section);
    const stock = $('[data-stock-note]', section);

    // Gallery dots (mobile)
    if (track && dots.length) {
      const items = $$('.gallery__item', track);
      const setActive = (i) => dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.min(i, items.length - 1));
      }, { passive: true });
      dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })));
    }

    // Lightbox
    if (track) {
      track.addEventListener('click', (e) => {
        const item = e.target.closest('.gallery__item');
        if (!item || !item.querySelector('img')) return;
        openLightbox(section, parseInt(item.dataset.index, 10) || 0);
      });
    }

    function render(variant) {
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      }
      if (stock) stock.hidden = !variant.available;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      const html = `<div class="price price--large${onSale ? ' price--sale' : ''}" data-price>
          <span class="price__regular">${formatMoney(variant.price)}</span>
          ${onSale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s><span class="price__save">−${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%</span>` : ''}
        </div>`;
      const priceWrap = $('[data-product-price]', section);
      if (priceWrap) priceWrap.innerHTML = html;
      if (stickyBar) {
        const sp = $('[data-sticky-price]', stickyBar);
        if (sp) sp.innerHTML = `<div class="price${onSale ? ' price--sale' : ''}"><span class="price__regular">${formatMoney(variant.price)}</span>${onSale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : ''}</div>`;
        const sv = $('[data-sticky-variant]', stickyBar);
        if (sv) sv.textContent = variant.title;
        const sb = $('[data-sticky-add]', stickyBar);
        if (sb) { sb.disabled = !variant.available; sb.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut; }
      }
      // jump gallery to the variant image
      if (variant.featured_media && track) {
        const target = $(`[data-media-id="${variant.featured_media.id}"]`, track);
        if (target) {
          if (window.innerWidth < 990) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          else if (target.dataset.index !== '0') {
            const first = track.firstElementChild;
            if (first !== target) {
              track.insertBefore(target, first);
            }
          }
        }
      }
      // URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function currentOptions() {
      const picker = $('[data-variant-picker]', section);
      if (!picker) return null;
      const opts = [];
      $$('fieldset', picker).forEach((fs, i) => {
        const checked = $('input:checked', fs);
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }

    function markAvailability(opts) {
      const picker = $('[data-variant-picker]', section);
      if (!picker) return;
      $$('fieldset', picker).forEach((fs, i) => {
        $$('input', fs).forEach(input => {
          const test = opts.slice();
          test[i] = input.value;
          const match = product.variants.find(v => v.options.every((o, k) => o === test[k]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
        const label = $(`[data-option-label="${i + 1}"]`, section);
        if (label) label.textContent = opts[i] || '';
      });
    }

    section.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const opts = currentOptions();
      const variant = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      markAvailability(opts);
      render(variant);
    });
    const init = currentOptions();
    if (init) markAvailability(init);

    // Sticky add-to-cart
    if (stickyBar && addBtn) {
      const sb = $('[data-sticky-add]', stickyBar);
      if (sb) sb.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
      const io = new IntersectionObserver(([en]) => {
        const below = en.boundingClientRect.top < 0;
        const show = !en.isIntersecting && below;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sb) sb.tabIndex = show ? 0 : -1;
      });
      io.observe(addBtn);
    }
  }

  /* ---------- Lightbox ---------- */
  let lightboxEl = null;
  function openLightbox(section, index) {
    lightboxEl = $('[data-lightbox]', section);
    if (!lightboxEl) return;
    $$('img[data-src]', lightboxEl).forEach(img => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
    lightboxEl.classList.add('is-open');
    document.body.classList.add('has-drawer');
    const trackEl = $('[data-lightbox-track]', lightboxEl);
    const item = $(`.lightbox__item[data-index="${index}"]`, trackEl);
    requestAnimationFrame(() => { if (item) trackEl.scrollLeft = item.offsetLeft; });
    $('[data-lightbox-close]', lightboxEl).focus();
  }
  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('is-open');
    document.body.classList.remove('has-drawer');
    lightboxEl = null;
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lightbox-close]')) closeLightbox();
  });

  /* ---------- Recommendations ---------- */
  function initRecommendations(root = document) {
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      try {
        const html = await (await fetch(el.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          if (window.__watchReveal) window.__watchReveal(el);
        }
      } catch (e) { /* ignore */ }
    });
  }

  /* ---------- Shop the look ---------- */
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.hotspot__dot');
    const look = e.target.closest('[data-look]');
    $$('.hotspot.is-active').forEach(h => {
      if (!dot || h !== dot.parentElement) { h.classList.remove('is-active'); const b = $('.hotspot__dot', h); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
    $$('.look__row.is-active').forEach(r => r.classList.remove('is-active'));
    if (dot && look) {
      const hs = dot.parentElement;
      const on = hs.classList.toggle('is-active');
      dot.setAttribute('aria-expanded', on ? 'true' : 'false');
      const row = $(`[data-hotspot-row="${hs.dataset.hotspot}"]`, look);
      if (row && on) row.classList.add('is-active');
    }
  });
  document.addEventListener('mouseover', (e) => {
    const row = e.target.closest('[data-hotspot-row]');
    if (!row) return;
    const look = row.closest('[data-look]');
    $$('.hotspot', look).forEach(h => h.classList.toggle('is-active', h.dataset.hotspot === row.dataset.hotspotRow));
  });

  /* ---------- Collection: filters, sort, load more ---------- */
  document.addEventListener('change', (e) => {
    const sort = e.target.closest('[data-sort]');
    if (sort) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }
    const facetForm = e.target.closest('[data-facets-form]');
    if (facetForm && facetForm.closest('.facets-sidebar')) {
      if (e.target.type === 'number') return;
      submitFacets(facetForm);
    }
  });
  document.addEventListener('focusout', (e) => {
    const f = e.target.closest('.facets-sidebar [data-facets-form]');
    if (f && e.target.type === 'number') submitFacets(f);
  });
  function submitFacets(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) { if (v === '') params.delete(k); }
    window.location.href = `${form.action}?${params.toString()}`;
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    submitFacets(form);
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      const html = await (await fetch(btn.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-grid]');
      const newItems = $$('[data-grid] > *', doc);
      newItems.forEach(n => grid.appendChild(n));
      if (window.__watchReveal) window.__watchReveal(grid);
      const total = parseInt(btn.dataset.total, 10);
      const shown = grid.children.length;
      const txt = $('[data-load-more-text]');
      const freshTxt = $('[data-load-more-text]', doc);
      if (txt && freshTxt) txt.textContent = freshTxt.textContent;
      const bar = $('[data-load-more-bar]');
      if (bar) bar.style.width = `${Math.min(100, shown * 100 / total)}%`;
      const next = $('[data-load-more-btn]', doc);
      if (next) { btn.href = next.href; btn.classList.remove('is-loading'); }
      else btn.remove();
    } catch (err) {
      window.location.href = btn.href;
    }
  });

  /* ---------- Login: recover form toggle ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-toggle-recover]');
    if (!t) return;
    e.preventDefault();
    const r = document.getElementById('recover');
    if (r) r.scrollIntoView({ behavior: 'smooth' });
  });

  /* ---------- Init ---------- */
  function initAll(root = document) {
    $$('[data-product-section]', root).forEach(initProduct);
    initRecommendations(root);
  }
  initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
